import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {UsersAvatarService} from "../../../serverService/usersAvatarService/UsersAvatarService";
import {useState} from "react";
import {RouteHelper} from "../../../route/RouteHelper";
import {
    RaikoBaseContainer, RaikoBreadcrumb, raikoBreadCrumbItemGenerator, RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import PredefinedAvatarDetailsBasicInfo from "./predefinedAvatarDetailsBasicInfo/PredefinedAvatarDetailsBasicInfo";
import PredefinedAvatarDetailsStatus from "./predefinedAvatarDetailsStatus/PredefinedAvatarDetailsStatus";
import PredefinedAvatar from "./predefinedAvatar/PredefinedAvatar";

export default function PredefinedAvatarDetails() {

    const navigate = useNavigate()
    const {state} = useLocation();
    const [searchParams] = useSearchParams();
    const title = searchParams.get("title");

    const {id: predefinedAvatarId = -1} = useParams()

    const [pageTitle, setPageTitle] = useState(state && state.title ? state.title : title ? title : RouteHelper.PredefinedAvatarDetails.name);

    const [tabSelectedValue, setTabSelectedValue] = useState(PredefinedAvatarDetailsTabTypes.Avatar.id);

    function handleChangeTab(event, newValue) {
        setTabSelectedValue(newValue)
    }

    const service = new UsersAvatarService()


    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn>
                <RaikoFlexFirstChildGrowOne>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.UsersAvatar.name,
                                RouteHelper.UsersAvatar.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                pageTitle,
                                ""
                            ),
                        ]}
                    />
                    <RaikoButtonSecondary label={"بازگشت"} onClick={_ => {
                        if (window.history.length > 2) {
                            navigate(-1);
                        } else {
                            navigate(RouteHelper.ResidencesManager.globalUrl);
                        }
                    }}/>
                </RaikoFlexFirstChildGrowOne>

                <TabContext value={tabSelectedValue}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                        <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                            <Tab
                                label={PredefinedAvatarDetailsTabTypes.Avatar.title}
                                value={PredefinedAvatarDetailsTabTypes.Avatar.id}
                            />
                            <Tab
                                label={PredefinedAvatarDetailsTabTypes.BasicInfo.title}
                                value={PredefinedAvatarDetailsTabTypes.BasicInfo.id}
                            />
                            <Tab
                                label={PredefinedAvatarDetailsTabTypes.Status.title}
                                value={PredefinedAvatarDetailsTabTypes.Status.id}
                            />
                        </TabList>
                    </Box>
                    <TabPanel value={PredefinedAvatarDetailsTabTypes.Avatar.id}>
                        <PredefinedAvatar service={service} predefinedAvatarId={predefinedAvatarId}/>
                    </TabPanel>
                    <TabPanel value={PredefinedAvatarDetailsTabTypes.BasicInfo.id}>
                         <PredefinedAvatarDetailsBasicInfo service={service} predefinedAvatarId={predefinedAvatarId}/>
                    </TabPanel>
                    <TabPanel value={PredefinedAvatarDetailsTabTypes.Status.id}>
                        <PredefinedAvatarDetailsStatus service={service} predefinedAvatarId={predefinedAvatarId}/>
                    </TabPanel>

                </TabContext>
            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}

const PredefinedAvatarDetailsTabTypes = {
    Avatar: {
        id: "avatar",
        title: "آواتار"
    },
    BasicInfo: {
        id: "basic-info",
        title: "اطلاعات پایه"
    },
    Status: {
        id: "status",
        title: "وضعیت انتشار"
    },
}